import React, { useState, useEffect } from "react";
import KickImage from 'Reuseables/KickImage';
import { connect } from "react-redux";
import { Container, Button, Row, Col } from "reactstrap";
import classNames from "classnames";
import Countdown, { zeroPad } from "react-countdown";
import moment from "moment";

import {
  getRaffleList,
  getClosedRaffleList,
  getRafflesToday,
  getUserRaffleTickets,
  getProductRaffleCount,
  postRaffleEntry,
  getRaffleGroup
} from "../../actions/kafairAction";

import { Banner, Content } from "../Assets";
import CardLoading from "../../components/Loading/CardLoading";
import FilterAndSort from "../../components/PageSearchDetails/FilterAndSort";
import { isFromAppBrowser, getCloudImageUrl } from "../../utils";
import SneakerImage from "../../components/Sneakers/SneakerImage";
import { TextRupiah } from "../../components/Text";
import { ModalAlert, ModalLoginNew } from "../../components/Modals";

const goldenTicket = require("../../images/golden-ticket.png");
const standardTicket = require("../../images/standard-ticket.png");
const GRANDPRIZE_IMAGE = require("../../images/grandprizeIcon.png");

const banner = {
  golden: require("../../images/novembazar_raffle_gold.png"),
  standard: require("../../images/novembazar_raffle_standard.png"),
  purple: require("../../images/rafflezone_flavorzone.jpg")
};

const renderer = ({ days, hours, minutes, seconds, completed }) => {
  if (completed) {
    return (
      <div>
        <span>
          {zeroPad(days)} : {zeroPad(hours)} : {zeroPad(minutes)} :{" "}
          {zeroPad(seconds)}
        </span>
      </div>
    );
  } else {
    return (
      <div className="countdown-wrapper">
        <span>
          {zeroPad(days)} : {zeroPad(hours)} : {zeroPad(minutes)} :{" "}
          {zeroPad(seconds)}
        </span>
      </div>
    );
  }
};

const ProductItem = ({
  item,
  getProductRaffleCount,
  redeemCount,
  changeCounter,
  ticket_type,
  color,
  counterRefreshed,
  isActive,
  isChildrenProduct,
  showError,
  hasStarted
}) => {
  const [counter, setCounter] = useState(0);
  const [raffleCount, setRaffleCount] = useState(redeemCount);
  useEffect(() => getRaffleCount(item.id), [
    item.id,
    redeemCount,
    counterRefreshed
  ]);
  function getRaffleCount(id) {
    if (getProductRaffleCount) {
      setCounter(0);
      getProductRaffleCount(id, ticket_type);
    }
  }
  function countUp() {
    const nextCounter = counter + 1;
    const nextRaffleCounter = raffleCount + 1;
    changeCounter(item.id, nextCounter)
      .then(res => {
        setCounter(nextCounter);
        setRaffleCount(nextRaffleCounter);
      })
      .catch(err => {
        showError(err);
      });
  }
  function countDown() {
    if (counter === 0) return;
    const nextCounter = counter - 1;
    const nextRaffleCounter = raffleCount - 1;
    changeCounter(item.id, nextCounter)
      .then(res => {
        setCounter(nextCounter);
        setRaffleCount(nextRaffleCounter);
      })
      .catch(err => {
        showError(err);
      });
  }

  function onChangeCounter(e) {
    const val = e.target.value;
    changeCounter(item.id, val ? parseInt(val) : 0)
      .then(res => {
        setCounter(val ? parseInt(val) : "");
        const nextRaffleCounter = raffleCount + parseInt(val);
        setRaffleCount(nextRaffleCounter);
      })
      .catch(err => {
        showError(err);
      });
  }
  function onBlur() {
    if (!counter) {
      setCounter(0);
    }
  }

  return (
    <Col xs={isChildrenProduct ? 12 : 6} md={isChildrenProduct ? 12 : 4}>
      <div
        className={classNames("product-card", {
          active: isActive,
          "full-width": isChildrenProduct
        })}
      >
        {!!redeemCount && hasStarted && (
          <div
            className={classNames("product-count")}
            style={{ backgroundColor: color }}
          >
            x {redeemCount}
          </div>
        )}
        {isChildrenProduct && (
          <KickImage
            src={GRANDPRIZE_IMAGE}
            style={{
              width: 110,
              height: 16,
              marginBottom: 5,
              opacity: isActive ? 1 : 0.3
            }}
          />
        )}
        <span className="productTitle">
          {item.brand && item.brand.name ? item.brand.name.toUpperCase() : ""}
        </span>
        <span className="productTitle">{item.display_name}</span>
        <SneakerImage
          hasImage={item.image ? true : false}
          src={item.image ? getCloudImageUrl(item.image, 400) : null}
          alt={item.display_name}
        />
        <span className="text-center">Get this for</span>
        <TextRupiah
          value={item.price}
          className="price-tag"
          color="black"
          bold={true}
          align="center"
        />
        {isActive && (
          <div class="counter-wrapper">
            <span class="counter-control" onClick={countDown}>
              -
            </span>
            <input
              className={classNames("counter-input", {
                "full-width": isChildrenProduct
              })}
              value={counter}
              onBlur={onBlur}
              pattern="[0-9]*"
              onChange={onChangeCounter}
            ></input>
            <span class="counter-control" onClick={countUp}>
              +
            </span>
          </div>
        )}
      </div>
    </Col>
  );
};

class RaffleTermOfService extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      showModalLogin: false,
      isLoggedIn: false,
      showModalInfo: false,
      isGolden: false,
      messageInfo: "",
      selectedProduct: [],
      rest_ticket: 0,
      counterRefreshed: 0,
      isSubmitting: false,
      ticket_type: false,
      group_name: null,
      selectedRaffleGroup: {},
      children_group: null
    };
  }

  componentDidMount() {
    this.props.getRaffleGroup();
    if (window.Intercom) {
      window.Intercom("update", {
        hide_default_launcher: true
      });
    }
    this.props.getUserRaffleTickets();
    this.unAuthHandler();
  }

  unAuthHandler = () => {
    const { dataAuth } = this.props;

    if (!dataAuth.isLogged) {
      this.setState({
        showModalLogin: true
      });
    }
  };

  componentWillUnmount() {
    if (window.Intercom) {
      window.Intercom("update", {
        hide_default_launcher: false
      });
    }
  }

  async componentDidUpdate(prevProps, prevState) {
    const {
      sliderImages,
      raffleGroup: { data: raffleGroupData },
      dataAuth
    } = this.props;
    const group_name = this.props.match.params.slug.replace(/\-/gi, "+");

    if (prevProps.match.params.slug !== this.props.match.params.slug) {
      const selectedRaffleGroup = raffleGroupData
        ? raffleGroupData.find(rg => rg.query === group_name) || {}
        : {};

      this.setState({ group_name, selectedRaffleGroup });
    }

    if (prevProps.dataAuth.userdata.isFetch && !dataAuth.userdata.isFetch) {
      this.setState({
        isLoggedIn: dataAuth.isLogged
      });

      if (!dataAuth.isLogged) {
        this.setState({
          showModalLogin: true
        });
      } else if (dataAuth.isLogged) {
        this.fetchAll();
      }
    }

    if (
      !dataAuth.signIn.isSubmit &&
      prevProps.dataAuth.signIn.isSubmit !== dataAuth.signIn.isSubmit
    ) {
      const { error, isSubmit } = dataAuth.signIn;
      const { dataCategory } = this.props;
      if (!error) {
        await this.setState({
          showModalLogin: false,
          isLoggedIn: true
        });
      } else {
        await this.setState({
          showModalLogin: true,
          isLoggedIn: false
        });
      }
    }

    if (prevState.showModalLogin !== this.state.showModalLogin) {
      const { error, isSubmit } = dataAuth.signIn;

      if (!this.state.showModalLogin && !this.state.isLoggedIn && !isSubmit) {
        this.props.history.push("/");
      }
    }

    if (
      prevProps.redeemRaffle.isFetching &&
      !this.props.redeemRaffle.isFetching
    ) {
      if (!this.props.redeemRaffle.error) {
        const amountOfTicket = this.props.redeemRaffle.redeemedTicket;
        this.setState(prevState => ({
          selectedProduct: [],
          counterRefreshed: prevState.counterRefreshed + 1,
          showModalInfo: true,
          messageInfo: `Berhasil memasukkan ${amountOfTicket} ticket${amountOfTicket !== 1 ? "s" : ""
            }. \nSemoga berhasil!!`
        }));

        this.getProductList();
        this.props.getUserRaffleTickets();
      } else {
        this.setState(prevState => ({
          selectedProduct: [],
          counterRefreshed: prevState.counterRefreshed + 1,
          showModalInfo: true,
          messageInfo:
            this.props.redeemRaffle.error.message ||
            "Sorry, something wrong! Try again later"
        }));
      }
    }
    if (
      prevProps.raffleGroup.isFetching &&
      !this.props.raffleGroup.isFetching
    ) {
      if (!this.props.raffleGroup.error) {
        this.setInitialGroupName();
      } else {
        this.setState({
          showModalInfo: true,
          messageInfo:
            this.props.raffleGroup.error.message ||
            "Sorry, something wrong! Try again later"
        });
      }
    }
    if (prevState.group_name !== this.state.group_name) {
      this.fetchAll();
    }
  }

  setInitialGroupName = () => {
    const {
      raffleGroup: { data: raffleGroupData }
    } = this.props;
    const group_name = this.props.match.params.slug.replace(/\-/gi, "+");

    const selectedRaffleGroup = raffleGroupData
      ? raffleGroupData.find(rg => rg.query === group_name) || {}
      : {};

    this.setState({ selectedRaffleGroup, group_name });
  };

  fetchAll = () => {
    const { group_name } = this.state;

    this.props.getRafflesToday(group_name);
    this.props.getUserRaffleTickets();
    this.getProductList();
  };

  getProductList = (page = 1) => {
    const { group_name } = this.state;

    if (!group_name) return;

    const {
      started_at,
      raffleGroup: { data: raffleGroupData }
    } = this.props;
    const startDate = moment(started_at).format("YYYYMMDD");
    const today = moment().format("YYYYMMDD");
    const hasStarted = moment(today).isAfter(startDate);

    const selectedRaffleGroup = raffleGroupData
      ? raffleGroupData.find(rg => rg.query === group_name)
      : {};
    const children =
      selectedRaffleGroup &&
        selectedRaffleGroup.children &&
        selectedRaffleGroup.children.length
        ? selectedRaffleGroup.children[0]
        : null;

    if (children) {
      this.setState({ children_group: children });
      this.props.getRafflesToday(children.query);
    } else {
      this.setState({ children_group: null });
    }

    const date = hasStarted || !started_at ? today : startDate;

    this.props.getRaffleList(group_name, date, page);
    this.props.getClosedRaffleList(group_name);
  };

  onCloseModal = () => {
    const { dataAuth } = this.props;

    this.setState({
      showModalLogin: false
    });
  };

  toggleModalInfo = () => {
    const { selectedProduct, selectedRaffleGroup } = this.state;
    const restTicket = this.hasSufficientTicket(selectedProduct);

    try {
      const group_name = this.props.match.params.slug.replace(/\-/gi, " ");

      this.setState({
        showModalInfo: !this.state.showModalInfo,
        messageInfo: `Anda memiliki ${restTicket} tiket untuk mengikuti ${selectedRaffleGroup.title}`
      });
    } catch (e) {
      console.log("error toggle modal info: ", e);
    }
  };

  showError = message => {
    this.setState({
      showModalInfo: true,
      messageInfo: message
    });
  };

  changeCounter = (itemId, val) => {
    return new Promise((resolve, reject) => {
      const { selectedProduct } = this.state;

      if (!this.isProductAlreadySelected(itemId)) {
        const nextSelectedProduct = [
          ...selectedProduct,
          {
            raffle_id: itemId,
            quantity: val
          }
        ];

        const rest_ticket = this.hasSufficientTicket(nextSelectedProduct);
        if (rest_ticket >= 0) {
          resolve(
            this.setState({
              selectedProduct: nextSelectedProduct,
              rest_ticket
            })
          );
        } else reject("You don't have enough ticket");
      } else {
        const nextSelectedProduct = selectedProduct.map(p => {
          if (p.raffle_id === itemId) {
            p.quantity = val;
          }

          return p;
        });

        if (this.hasSufficientTicket(nextSelectedProduct) >= 0) {
          resolve(
            this.setState({
              selectedProduct: nextSelectedProduct
            })
          );
        } else {
          const nextSelectedProduct = selectedProduct.map(p => {
            if (p.raffle_id === itemId) {
              p.quantity = val - 1;
            }

            return p;
          });
          reject("You don't have enough ticket");
        }
      }
    });
  };

  hasSufficientTicket(nextSelectedProduct) {
    const { selectedRaffleGroup } = this.state;
    const { userRaffleTicket } = this.props;
    const user_ticket =
      userRaffleTicket &&
        userRaffleTicket.data &&
        userRaffleTicket.data[selectedRaffleGroup.ticket_type]
        ? userRaffleTicket.data[selectedRaffleGroup.ticket_type].total
        : 0;

    const sumOfTicket = nextSelectedProduct.reduce(
      (total, currentVal) => total + parseInt(currentVal.quantity),
      0
    );
    const restTicket = user_ticket - sumOfTicket;

    return restTicket;
  }

  isProductAlreadySelected = itemId => {
    const { selectedProduct } = this.state;
    return selectedProduct.find(p => p.raffle_id == itemId);
  };

  setActiveGroup = selectedRaffleGroup => {
    this.setState({
      group_name: selectedRaffleGroup.query,
      selectedRaffleGroup
    });
  };

  renderButtonGroups = () => {
    const {
      raffleGroup: { data: raffleGroupData },
      userRaffleTicket
    } = this.props;
    const { selectedRaffleGroup, group_name } = this.state;

    if (!raffleGroupData || raffleGroupData.length === 0) return null;

    return (
      <div className="raffle-group-button-wrapper">
        {raffleGroupData.map(rg => {
          const isSelected = group_name === rg.query;
          const color =
            userRaffleTicket &&
              userRaffleTicket.data &&
              rg &&
              userRaffleTicket.data[rg.ticket_type]
              ? userRaffleTicket.data[rg.ticket_type].color
              : "#fff";
          const button_bg =
            userRaffleTicket &&
              userRaffleTicket.data &&
              rg &&
              userRaffleTicket.data[rg.ticket_type]
              ? userRaffleTicket.data[rg.ticket_type].btn_signed_url
              : "#fff";

          return (
            <div
              className={"raffle-group-button"}
              onClick={e => {
                e.preventDefault();
                this.setActiveGroup(rg);
              }}
              style={!isSelected ? { borderColor: color } : {}}
            >
              {isSelected && <KickImage src={button_bg} />}
              <span style={!isSelected ? { color: color } : {}}>
                {rg.ticket_name}
              </span>
            </div>
          );
        })}
      </div>
    );
  };

  renderChildrenList = () => {
    const {
      children_group,
      counterRefreshed,
      selectedProduct,
      selectedRaffleGroup,
      ticket_type
    } = this.state;
    const { raffle, userRaffleTicket, raffleProduct } = this.props;
    const section = raffle[children_group && children_group.query];

    if (!children_group || !section) return null;

    const products = section.products || [];
    const isStart = moment().isAfter(section.start_date);
    const isExpired = moment().isAfter(section.expiry);
    const { currency, ratio, getProductRaffleCount } = this.props;
    const restTicket = this.hasSufficientTicket(selectedProduct);

    const ticket_bg =
      userRaffleTicket &&
      userRaffleTicket.data &&
      userRaffleTicket.data[children_group.ticket_type] &&
      userRaffleTicket.data[children_group.ticket_type].ticket_signed_url;
    const redeem_count_bg =
      userRaffleTicket &&
      userRaffleTicket.data &&
      userRaffleTicket.data[selectedRaffleGroup.ticket_type] &&
      userRaffleTicket.data[selectedRaffleGroup.ticket_type].badge_img_url;

    return (
      <div className="raffle-group">
        <div className="title-wrapper">
          <span>{isStart ? "Berakhir Dalam" : "Mulai Dalam"}</span>
        </div>
        <Countdown
          date={
            isStart
              ? moment(section.expiry).toISOString()
              : moment(section.start_date).toISOString()
          }
          daysInHours={true}
          zeroPadTime={2}
          renderer={renderer}
          iStart={isStart}
        />
        <Container>
          <Row className="product-wrapper">
            {products.length > 0
              ? products.map((item, index) => {
                const redeemCount = raffleProduct
                  ? raffleProduct[item.id]
                  : 0;
                return (
                  <ProductItem
                    item={item}
                    getProductRaffleCount={this.props.getProductRaffleCount}
                    redeemCount={redeemCount}
                    changeCounter={this.changeCounter}
                    counterRefreshed={counterRefreshed}
                    ticket_type={selectedRaffleGroup.ticket_type}
                    color={selectedRaffleGroup.color}
                    isActive={isStart}
                    showError={this.showError}
                    isChildrenProduct
                    hasStarted={isStart}
                  />
                );
              })
              : null}
          </Row>
        </Container>
      </div>
    );
  };

  renderRaffleList = () => {
    const { group_name } = this.state;
    if (!group_name) return null;

    const {
      selectedProduct,
      selectedRaffleGroup,
      counterRefreshed,
      isGolden,
      isLoading
    } = this.state;
    const {
      raffleList,
      currency,
      ratio,
      getProductRaffleCount,
      dataAuth,
      raffleProduct
    } = this.props;
    let infoShown = 0;

    if (!dataAuth.isLogged) return null;

    const list =
      (raffleList &&
        raffleList[group_name] &&
        raffleList[group_name].active &&
        raffleList[group_name].active.list) ||
      {};

    if (isLoading && Object.keys(list).length === 0)
      return (
        <div
          style={{
            flex: 1,
            justifyContent: "center",
            alignItems: "center",
            marginTop: 30
          }}
        >
          Loading..
        </div>
      );

    const restTicket = this.hasSufficientTicket(selectedProduct);
    return Object.keys(list).map((date, index) => {
      const section = list[date];
      const { products } = section;
      const isStart = moment().isAfter(section.start);
      const isExpired = moment().isAfter(section.expiry);

      if (isStart) infoShown++;

      // if(isExpired) return null;

      return (
        <div key={index} className="raffle-group">
          <div className="title-wrapper">
            <span className="group-title">{section.group_name}</span>
            <span>{isStart ? "Berakhir Dalam" : "Mulai Dalam"}</span>
          </div>
          <Countdown
            date={
              isStart
                ? moment(section.expiry).toISOString()
                : moment(section.start).toISOString()
            }
            daysInHours={true}
            zeroPadTime={2}
            renderer={renderer}
            iStart={isStart}
          />
          <Container>
            <Row className="product-wrapper">
              {products.length > 0
                ? products.map((item, index) => {
                  const redeemCount = raffleProduct
                    ? raffleProduct[item.id]
                    : 0;
                  return (
                    <ProductItem
                      item={item}
                      getProductRaffleCount={this.props.getProductRaffleCount}
                      redeemCount={redeemCount}
                      changeCounter={this.changeCounter}
                      ticket_type={selectedRaffleGroup.ticket_type}
                      color={selectedRaffleGroup.color}
                      counterRefreshed={counterRefreshed}
                      isActive={isStart}
                      hasStarted={isStart}
                      showError={this.showError}
                    />
                  );
                })
                : null}
            </Row>
          </Container>
        </div>
      );
    });
  };
  renderClosedRaffleList = () => {
    const group_name = this.props.match.params.slug.replace(/\-/gi, "+");
    const {
      selectedProduct,
      selectedRaffleGroup,
      counterRefreshed,
      isGolden,
      isLoading
    } = this.state;
    const {
      raffleList,
      currency,
      ratio,
      getProductRaffleCount,
      dataAuth,
      raffleProduct
    } = this.props;
    let infoShown = 0;

    if (!dataAuth.isLogged) return null;

    const products =
      raffleList && raffleList[group_name]
        ? raffleList[group_name].closed || []
        : [];

    if (products.length === 0) return null;

    return (
      <div className="raffle-group">
        <div className="title-wrapper">
          <span className="group-title">SUDAH BERAKHIR</span>
        </div>

        <Container>
          <Row className="product-wrapper">
            {products.length > 0
              ? products.map((item, index) => {
                const redeemCount = raffleProduct
                  ? raffleProduct[item.id]
                  : 0;
                return (
                  <ProductItem
                    item={item}
                    getProductRaffleCount={this.props.getProductRaffleCount}
                    redeemCount={redeemCount}
                    changeCounter={this.changeCounter}
                    ticket_type={selectedRaffleGroup.ticket_type}
                    color={selectedRaffleGroup.color}
                    hasStarted={true}
                    showError={this.showError}
                  />
                );
              })
              : null}
          </Row>
        </Container>
      </div>
    );
  };

  doSubmitRedeem = () => {
    const { selectedProduct } = this.state;
    this.props.postRaffleEntry(selectedProduct);
  };

  render() {
    const { selectedRaffleGroup } = this.state;
    const { raffle } = this.props;
    const imageBanner = banner[selectedRaffleGroup.ticket_type];

    const raffle_type = selectedRaffleGroup.ticket_type;

    return (
      <Container fluid className="main-container" id="home-container">
        <ModalLoginNew
          isOpen={this.state.showModalLogin}
          onClosed={this.onCloseModal}
        />
        <ModalAlert
          isOpen={this.state.showModalInfo}
          contentText={this.state.messageInfo}
          showButton={false}
          onToggle={this.toggleModalInfo}
        />
        <Banner src={imageBanner} alt="Raffle Banner KA Fair" />

        <div className="raffle-container">
          <div className="tos">
            {raffle_type === "golden" && (
              <>
                <p className="title">T&C Penggunaan Raffle Ticket:</p>
                <ol>
                  <li>
                    Jumlah ticket raffle dapat dilihat ketika user sudah
                    melakukan log in dan melakukan transaksi sesuai dengan
                    ketentuan yang berlaku.
                  </li>
                  <li>
                    Penggunaan Gold Ticket hanya bisa dilakukan pada section
                    Gold Raffle by Bank Mandiri.
                  </li>
                  <li>
                    Penggunaan Green Ticket hanya bisa dilakukan pada section
                    Green Raffle.
                  </li>
                </ol>

                <p className="title">Cara mendapatkan Gold Ticket:</p>
                <ol>
                  <li>
                    User wajib menggunakan Kartu Mandiri Debit / Mandiri Kartu
                    Kredit dalam transaksi pembelian di platform Kick Avenue.
                  </li>
                  <li>
                    Pembelian produk yang berlogo Novembazaar (
                    <KickImage src={require("../../images/novembazaar_logo.png")} />)
                    dengan details sebagai berikut:
                    <ul>
                      <li>
                        Nasabah Kartu Mandiri Debit: Dengan kelipatan IDR
                        100.000 akan mendapatkan <strong>2 Gold Tickets</strong>
                        .
                      </li>
                      <li>
                        Nasabah Mandiri Kartu Kredit: Dengan kelipatan IDR
                        100.000 akan mendapatkan <strong>1 Gold Ticket</strong>.
                      </li>
                    </ul>
                  </li>
                  <li>
                    Berikut jadwal serta produk pada kategori Gold Raffle by
                    Bank Mandiri:
                  </li>
                </ol>
                <KickImage src={require("../../images/jadwal-raffle.png")} />
              </>
            )}
            {raffle_type === "standard" && (
              <>
                <p className="title">Cara mendapatkan Green Ticket:</p>
                <ol>
                  <li>
                    Pembelian produk yang berlogo Novembazaar (
                    <KickImage src={require("../../images/novembazaar_logo.png")} />)
                    dengan details sebagai berikut:
                    <ul>
                      <li>
                        Sneakers: Dengan kelipatan IDR 100.000 akan mendapatkan{" "}
                        <strong>1 Green Ticket.</strong>
                      </li>
                      <li>
                        Apparel, Luxury and Electronics & Collectibles: Dengan kelipatan IDR
                        100.000 akan mendapatkan{" "}
                        <strong>2 Green Tickets.</strong>
                      </li>
                    </ul>
                  </li>
                  <li>
                    Pembelian dengan metode pembayaran apapun akan mendapatkan{" "}
                    <strong>Green Tickets</strong> sesuai dengan akumulasi yang
                    tersedia.
                  </li>
                  <li>
                    Berikut jadwal serta produk pada kategori Green Raffle:
                  </li>
                </ol>
                <KickImage src={require("../../images/jadwal-raffle-green.png")} />
              </>
            )}
            {raffle_type === "purple" && (
              <>
                <p className="title">
                  Terms and Conditions Penggunaan Raffle Ticket:
                </p>
                <ul>
                  <ol>
                    1. Jumlah ticket raffle dapat dilihat ketika user sudah
                    melakukan log in dan melakukan transaksi sesuai dengan
                    ketentuan yang berlaku
                  </ol>
                  <ol>
                    2. Penggunaan Purple Ticket hanya bisa dilakukan pada
                    section Purple / Flavour Zone by Camel
                  </ol>
                </ul>

                <p className="title">Cara mendapatkan Purple Ticket :</p>
                <ul>
                  <ol>
                    1. Pembelian produk apapun di section Capsule Zone, setiap
                    kelipatan IDR 100.000 akan mendapatkan 1 purple ticket
                  </ol>
                  <ol>
                    2. Pembelian official merchandise dari Kick Avenue akan
                    mendapatkan Purple Ticket sesuai produk yang kamu pilih
                    (jumlah tiket yang di dapat bisa di cek pada kolom
                    description setiap product)
                  </ol>
                </ul>
              </>
            )}
          </div>
        </div>
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  dataAuth: state.dataAuth,
  raffleGroup: state.dataKaFair.raffleGroup,
  raffle: state.dataKaFair.raffle,
  raffleList: state.dataKaFair.raffleList,
  raffleProduct: state.dataKaFair.raffleProducts,
  userRaffleTicket: state.dataKaFair.userRaffleTicket,
  redeemRaffle: state.dataKaFair.redeemRaffle,
  sliderImages: state.sliderHome,
  dataCategory: state.dataCategory.selected
});

const mapDispatchToProps = dispatch => ({
  getRaffleList: (group_name, date) =>
    dispatch(getRaffleList(group_name, date)),
  getClosedRaffleList: group_name => dispatch(getClosedRaffleList(group_name)),
  getProductRaffleCount: (raffle_id, ticket_type) =>
    dispatch(getProductRaffleCount(raffle_id, ticket_type)),
  getRafflesToday: group_name => dispatch(getRafflesToday(group_name)),
  getUserRaffleTickets: () => dispatch(getUserRaffleTickets()),
  postRaffleEntry: raffles => dispatch(postRaffleEntry(raffles)),
  getRaffleGroup: () => dispatch(getRaffleGroup())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RaffleTermOfService);
